import axiosClient from '../axiosClient';

export const pendingDispatchApi = {
  getPendingInvoices: async (page = 0, size = 20, search = '', month = '', status = '', sortBy = '', sortOrder = 'desc') => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });

      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      if (month && month.trim() !== '') {
        params.append('month', month.trim());
      }

      if (status && status.trim() !== '') {
        params.append('status', status.trim());
      }

      if (sortBy && sortBy.trim() !== '') {
        params.append('sortBy', sortBy.trim());
        params.append('sortOrder', sortOrder);
      }

      console.log('📦 Fetching pending dispatch invoices with params:', params.toString());

      const data = await axiosClient.get(`/pending-dispatch?${params.toString()}`);
      
      console.log('📦 Pending Dispatch API data:', data);
      
      return data;
    } catch (error) {
      console.error('Error fetching pending dispatch invoices:', error);
      throw error;
    }
  },

  exportPendingInvoices: async (search = '', month = '', status = '') => {
    try {
      const params = new URLSearchParams();
      
      if (search && search.trim() !== '') {
        params.append('search', search.trim());
      }

      if (month && month.trim() !== '') {
        params.append('month', month.trim());
      }

      if (status && status.trim() !== '') {
        params.append('status', status.trim());
      }

      console.log('📊 Exporting pending dispatch invoices with params:', params.toString());

      const data = await axiosClient.get(`/pending-dispatch/export?${params.toString()}`);
      return data;
    } catch (error) {
      console.error('Error exporting pending dispatch invoices:', error);
      throw error;
    }
  },

  getInvoiceDetails: async (invoiceNum) => {
    try {
      console.log('🔍 Fetching pending invoice details for:', invoiceNum);
      const data = await axiosClient.get(`/pending-dispatch/${invoiceNum}`);
      return data;
    } catch (error) {
      console.error('Error fetching pending invoice details:', error);
      throw error;
    }
  },
};